import { Order_PayPalCreateOrder as apiCall } from "./backend"
const createPayPalOrder = async () => {
    let res = await apiCall({
        cmd: {
            orderId: localStorage.getItem('CURRENT_ID'),
            key: localStorage.getItem('TOKEN')
        }
    });
    return res.data;
}



export default {
    createPayPalOrder
}